import { render, staticRenderFns } from "./OappMenu.vue?vue&type=template&id=4f108516&scoped=true&"
import script from "./OappMenu.vue?vue&type=script&lang=js&"
export * from "./OappMenu.vue?vue&type=script&lang=js&"
import style0 from "./OappMenu.vue?vue&type=style&index=0&id=4f108516&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f108516",
  null
  
)

export default component.exports